export function getQueryVariable(queryString, targetVariable) {
  var queryParameters = queryString.split("&");
  for (var i = 0; i < queryParameters.length; i++) {
    var parameterPair = queryParameters[i].split("=");
    var parameterName = parameterPair[0];
    var parameterValue = parameterPair[1];
    if (parameterName === targetVariable) {
      return parameterValue;
    }
  }
  return false;
}